var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5518_7179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 7.39386C8.33422 7.39386 8.60574 7.66537 8.60574 7.99992V10.4242C8.60574 10.7587 8.33422 11.0302 7.99967 11.0302C7.66513 11.0302 7.39361 10.7587 7.39361 10.4242V7.99992C7.39361 7.66537 7.66513 7.39386 7.99967 7.39386ZM7.99967 4.96962C8.33422 4.96962 8.60574 5.24113 8.60574 5.57568C8.60574 5.91022 8.33422 6.18174 7.99967 6.18174C7.66513 6.18174 7.39361 5.91022 7.39361 5.57568C7.39361 5.24113 7.66513 4.96962 7.99967 4.96962ZM7.99967 2.54537C4.98694 2.54537 2.54513 4.9872 2.54513 7.99992C2.54513 11.0126 4.98694 13.4545 7.99967 13.4545C11.0124 13.4545 13.4542 11.0126 13.4542 7.99992C13.4542 4.9872 11.0124 2.54537 7.99967 2.54537ZM7.99967 1.33325C11.6815 1.33325 14.6663 4.3181 14.6663 7.99992C14.6663 11.6817 11.6815 14.6666 7.99967 14.6666C4.31785 14.6666 1.33301 11.6817 1.33301 7.99992C1.33301 4.3181 4.31785 1.33325 7.99967 1.33325Z",
    fill: "#2D3748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5518_7179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(1.33301 1.33325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.31b273f781a5ecf4348d9052878ccd4c.svg";
export { ForwardRef as ReactComponent };